var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from './useTheme';
/**
 * withTheme is a Higher Order Component that hides the use of
 * React's Context API, allowing user components to receive a theme
 * without directly using the Context Consumer. It is recommended
 * that users only use this if they cannot use the consumer pattern.
 */
export function withTheme(WrappedComponent) {
    // Try to create a nice displayName for React Dev Tools.
    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var ComponentWithTheme = function (props) {
        var theme = useTheme();
        // props comes afterwards so the can override the default ones.
        return _jsx(WrappedComponent, __assign({}, props, { theme: theme }), void 0);
    };
    ComponentWithTheme.displayName = "withTheme(" + displayName + ")";
    return ComponentWithTheme;
}
